// extracted by mini-css-extract-plugin
export default {"table-body":"TableBody_table-body__Eqagf","table-body-wrp":"TableBody_table-body-wrp__ko96X","body":"TableBody_body__2Y-aF"};